module.exports = __webpack_public_path__ + "img/07b3663.png";